/** Display name and logo for an exchange code as alerts store it (announcing or trading venue). */
export interface ExchangeBrand {
  name: string;
  logo: string | null;
}

const BRANDS: Record<string, ExchangeBrand> = {
  binance: { name: "Binance", logo: "/exchanges-logo/binance.webp" },
  bybit: { name: "Bybit", logo: "/exchanges-logo/bybit.webp" },
  gate: { name: "Gate", logo: "/exchanges-logo/gateio.webp" },
  gateio: { name: "Gate", logo: "/exchanges-logo/gateio.webp" },
  kucoin: { name: "KuCoin", logo: "/exchanges-logo/kucoin.webp" },
  hyperliquid: { name: "Hyperliquid", logo: "/exchanges-logo/hyperliquid.webp" },
  aster: { name: "Aster", logo: "/exchanges-logo/aster.webp" },
  asterdex: { name: "Aster", logo: "/exchanges-logo/aster.webp" },
  upbit: { name: "Upbit", logo: "/exchanges-logo/upbit.svg" },
  bithumb: { name: "Bithumb", logo: "/exchanges-logo/bithumb.png" },
  coinbase: { name: "Coinbase", logo: "/exchanges-logo/coinbase.png" },
  okx: { name: "OKX", logo: null },
  bitget: { name: "Bitget", logo: null },
  mexc: { name: "MEXC", logo: null },
};

export function exchangeBrand(code: string | null | undefined): ExchangeBrand {
  const key = (code ?? "").toLowerCase().trim();
  if (BRANDS[key]) return BRANDS[key];
  const name = key ? key[0].toUpperCase() + key.slice(1) : "Unknown";
  return { name, logo: null };
}

/** "spot" → "Spot", "pre-market" → "Pre-market". */
export function marketTypeLabel(type: string | null | undefined): string {
  const value = (type || "spot").trim();
  return value[0].toUpperCase() + value.slice(1);
}

/** The scanners write some venues two ways (gate/gateio, aster/asterdex). */
export function canonicalExchangeCode(code: string | null | undefined): string {
  const key = (code ?? "").toLowerCase().trim();
  if (key === "gateio") return "gate";
  if (key === "aster") return "asterdex";
  return key;
}
